import { useEffect } from 'react'
import {
    useLocation,
} from 'react-router-dom'

import {
    useQuery,
} from '@tanstack/react-query'

import preCheckCandidateViewMutation from './services/pre-check-candidate-view'
import IdResultView from '../../Components/IdResultView'
import { trackEvent } from '../../utils/analytics'

const PreCheckCandidateView = () => {
    const location = useLocation()

    const queryParams = new URLSearchParams(location.search)
    const key = queryParams.get('key')

    const {
        data,
        error,
        isFetching,
    } = useQuery({
        queryKey: ['pre-check-candidate-view', key],
        queryFn: () => preCheckCandidateViewMutation({ key }),
        refetchOnWindowFocus: false,
    })

    // Fire once the card data arrives successfully.
    useEffect(() => {
        if (data) {
            trackEvent('trucheck_card_view', { viewer_role: 'candidate', source: 'candidate_view' })
        }
    }, [data])

    return (
        <IdResultView
            data={data}
            referenceId={key}
            isFetching={isFetching}
            error={error}
            viewerRole="candidate"
        />
    )
}

export default PreCheckCandidateView
